import { render, staticRenderFns } from "./StoresSearch.vue?vue&type=template&id=139edc08&"
import script from "./StoresSearch.vue?vue&type=script&lang=js&"
export * from "./StoresSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports